export const parseTenantCode = (value: string | undefined): number | null => {
  if (!value || !/^[1-9]\d*$/.test(value)) return null

  const code = Number(value)
  return Number.isSafeInteger(code) ? code : null
}
